const fr = {
  /* =========================================================
     NAVIGATION
  ========================================================= */

  nav: {
    home: "Accueil",
    services: "Services web",
    projects: "Réalisations",
    about: "À propos",
    contact: "Contact",
    login: "Connexion",
  },

  /* =========================================================
     COMMUN
  ========================================================= */

  common: {
    learnMore: "En savoir plus",
    viewMore: "Voir plus",
    discover: "Découvrir",
    contactUs: "Nous contacter",
    getStarted: "Commencer",
    send: "Envoyer",
    submit: "Valider",
    cancel: "Annuler",
    close: "Fermer",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    loading: "Chargement...",
    error: "Une erreur est survenue.",
    success: "Succès",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
  },

  /* =========================================================
     ESPACE CLIENT
  ========================================================= */

  clientSpace: {
    overline: "[ ESPACE CLIENT ]",

    logout: "Déconnexion",

    requests: "Vos demandes",
    noRequests: "Aucune demande pour l'instant.",
    newRequest: "Nouvelle demande",

    support: "Support",
    supportEmpty:
      "Une question ? Écrivez à notre équipe, nous répondons rapidement.",

    placeholder: "Votre message…",

    request: "Demande",
    supportLabel: "Support",

    status: {
      received: "Reçu",
      inProgress: "En cours",
      delivered: "Livré",
    },
  },

  /* =========================================================
     HOME
  ========================================================= */

  home: {
    overline: "[ STUDIO WEB — CRÉATION DIGITALE ]",

    title: [
      "Votre",
      "présence",
      "digitale.",
    ],

    description:
      "HollowCorp est un studio web indépendant spécialisé dans la création de sites internet modernes, rapides et sur mesure pour les entreprises, artisans, commerçants et indépendants en France et en Europe.",

    cta: "Parlons de votre projet",

    servicesTitle:
      "Création de sites web pensée pour votre activité.",

    servicesDescription:
      "Deux formules : site vitrine (présentation, contact, mise en ligne simple) ou web app (espace client, emails, serveur). Le prix suit le temps et les ressources, pas un forfait unique.",
  },

  /* =========================================================
     À PROPOS
  ========================================================= */

  about: {
    overline: "[ À PROPOS DE HOLLOWCORP ]",

    title: [
      "Votre",
      "présence",
      "digitale.",
    ],

    description:
      "HollowCorp est un studio web indépendant qui accompagne les entreprises dans la création, la refonte et la maintenance de sites internet. Notre approche combine design, développement web, performance, référencement naturel SEO et expérience utilisateur.",

  },

  /* =========================================================
     SERVICES
  ========================================================= */

  services: {
    overline: "[ HOLLOWCORP — SERVICES WEB ]",

    heroLines: [
      "Nos",
      "services web",
    ],

    heroDescription:
      "HollowCorp conçoit des sites internet sur mesure pour les entreprises en France et en Europe. Création de sites vitrines, e-commerce, applications web, refonte, référencement SEO, hébergement et maintenance : nous vous accompagnons de la conception à la mise en ligne.",

    /* -------------------------------------------------------
       SERVICES
    ------------------------------------------------------- */

    list: [
      {
        id: "01",

        title: "Création de sites internet",

        description:
          "Création de sites web professionnels sur mesure pour entreprises, artisans, commerçants et indépendants. Sites vitrines et e-commerce rapides, modernes, responsive et conçus pour convertir.",

        tags: [
          "Site vitrine",
          "E-commerce",
          "Site sur mesure",
        ],
      },

      {
        id: "02",

        title: "Refonte de site web",

        description:
          "Votre site internet est ancien ou peu performant ? Nous modernisons son design, sa structure, son expérience utilisateur et ses performances tout en préservant et en améliorant ses bases SEO.",

        tags: [
          "Refonte",
          "Redesign",
          "UX / UI",
        ],
      },

      {
        id: "03",

        title: "Applications web",

        description:
          "Développement d'applications web sur mesure : espaces membres, tableaux de bord, systèmes de réservation, outils internes, back-office et plateformes web évolutives.",

        tags: [
          "Application web",
          "Dashboard",
          "SaaS",
        ],
      },

      {
        id: "04",

        title: "SEO, conseil & maintenance",

        description:
          "Amélioration du référencement naturel SEO, optimisation technique, maintenance, sécurité et accompagnement. Nous gardons votre site internet rapide, sécurisé et à jour.",

        tags: [
          "SEO",
          "Référencement naturel",
          "Maintenance",
        ],
      },
    ],

    /* -------------------------------------------------------
       ACTIVITÉS
    ------------------------------------------------------- */

    businessOverline: "[ POUR VOTRE ACTIVITÉ ]",

    businessTitle: "Un site web adapté à",

    businessTitleAccent: "votre entreprise",

    businessDescription:
      "Artisan, commerçant, restaurant, indépendant, association, TPE ou PME : HollowCorp crée des sites internet adaptés à votre activité, vos objectifs et vos clients. Chaque projet est conçu pour présenter clairement vos services et faciliter la prise de contact.",

    businessTypes: [
      "Artisans",
      "Commerçants",
      "Restaurants",
      "Indépendants",
      "TPE et PME",
      "Associations",
      "Professions libérales",
      "Entreprises",
    ],

    /* -------------------------------------------------------
       PROCESSUS
    ------------------------------------------------------- */

    processOverline: "[ MÉTHODE HOLLOWCORP ]",

    processTitle: "Comment ça",

    processAccent: "marche",

    processDescription:
      "Un processus simple et transparent pour créer votre site internet : comprendre votre activité, définir vos objectifs, concevoir votre identité et votre expérience utilisateur, développer le site puis assurer son suivi.",

    process: [
      {
        num: "01",

        title: "Échange",

        body:
          "Nous échangeons sur votre activité, vos objectifs, vos besoins et vos clients. Vous recevez une proposition claire et adaptée à votre projet de site web.",
      },

      {
        num: "02",

        title: "Conception",

        body:
          "Nous définissons l'identité visuelle, l'arborescence, la structure des pages et l'expérience utilisateur de votre futur site internet.",
      },

      {
        num: "03",

        title: "Développement",

        body:
          "Votre site est développé sur mesure, responsive, rapide et pensé dès le départ avec de bonnes bases techniques, d'accessibilité et de référencement naturel SEO.",
      },

      {
        num: "04",

        title: "Mise en ligne & suivi",

        body:
          "Après la mise en ligne, HollowCorp assure l'hébergement, la maintenance, les mises à jour de sécurité et les évolutions de votre site web.",
      },
    ],

    /* -------------------------------------------------------
       MODIFICATIONS
    ------------------------------------------------------- */

    modificationsOverline: "[ MODIFICATIONS ]",

    modificationsTitle:
      "Votre site évolue.",

    modificationsAccent:
      "Sans surprise.",

    modificationsDescription:
      "Votre abonnement inclut des modifications afin de garder votre site internet à jour. Vous pouvez faire évoluer vos contenus et certaines fonctionnalités sans devoir repartir de zéro.",

    modifications: [
      {
        title: "Modifications majeures",

        badge: "2 / semestre",

        body:
          "Deux modifications majeures sont incluses chaque semestre. Une modification majeure supplémentaire peut être demandée pour 25 €.",
      },

      {
        title: "Petites modifications",

        badge: "5 / 2 mois",

        body:
          "Jusqu'à 5 petites modifications sont incluses tous les 2 mois afin de faire évoluer votre site régulièrement.",
      },

      {
        title: "Erreur de notre part",

        badge: "100% inclus",

        body:
          "Les corrections nécessaires en cas d'erreur, de bug ou de problème provenant de HollowCorp sont entièrement prises en charge.",
      },
    ],

    modificationsNote:
      "Les limites concernent uniquement les demandes de modification de contenu ou de fonctionnalités souhaitées par le client. Les corrections de bugs, erreurs ou problèmes directement imputables à HollowCorp restent entièrement prises en charge et ne sont pas décomptées.",

    /* -------------------------------------------------------
       PRÉSENCE EN LIGNE
    ------------------------------------------------------- */

    onlineOverline:
      "[ PRÉSENCE EN LIGNE & SEO ]",

    onlineTitle:
      "Construire une présence",

    onlineAccent:
      "qui vous ressemble",

    onlineParagraph1:
      "Un site internet professionnel doit être utile à votre entreprise et à vos visiteurs. HollowCorp travaille la structure, le design, l'expérience utilisateur et les performances pour créer un site cohérent sur ordinateur, tablette et mobile.",

    onlineParagraph2:
      "Les fondamentaux du référencement naturel SEO sont intégrés dès la conception : structure des pages, contenu pertinent, titres et balises essentielles, performances techniques, responsive design et organisation claire de l'information.",

    onlineParagraph3:
      "L'objectif est de permettre à vos visiteurs de comprendre rapidement votre activité, trouver vos services, découvrir votre entreprise et vous contacter facilement.",

    /* -------------------------------------------------------
       TARIFICATION
    ------------------------------------------------------- */

    pricingOverline:
      "[ TARIFS — DEUX FORMULES ]",

    pricingTitle: [
      "Deux formules,",
    ],

    pricingAccent: [
      "sans surprise",
    ],

    firstMonth:
      "le 1er mois",

    perMonth:
      "/ mois ensuite",

    pricingButton:
      "Demander un devis",

    offers: {
      overline: "[ TARIFS — DEUX FORMULES ]",
      title: "Deux formules,",
      accent: "sans surprise",
      intro:
        "Un site vitrine présente votre activité. Une web app va plus loin (espace client, emails, back-office) : plus de temps, plus de serveurs, donc plus cher — surtout le premier mois.",
      cta: "Demander cette offre",
      note:
        "Le premier mois couvre la création et la mise en ligne. Ensuite, l'abonnement paie l'hébergement, le nom de domaine et les petites modifications. Une web app reste plus chère chaque mois parce qu'elle tourne sur un serveur dédié, pas seulement sur un hébergement vitrine.",
      vitrine: {
        name: "Site vitrine",
        badge: "Le plus simple",
        desc: "Comme L'Atelier du Quai : accueil, services ou carte, contact. Idéal restaurant, artisan, profession libérale.",
        included: [
          "Hébergement et nom de domaine inclus",
          "Site responsive (téléphone, ordi)",
          "SEO de base (Google)",
          "Jusqu'à 3 petites modifications / 2 mois",
          "Sans espace membre ni backend",
        ],
      },
      webapp: {
        name: "Web app",
        badge: "Plus de temps, plus de puissance",
        desc: "Comme hollowcorp.fr : formulaires, emails, espace client, administration. Premier mois plus élevé : conception et serveur.",
        included: [
          "Hébergement vitrine + serveur applicatif",
          "Emails transactionnels inclus",
          "Espace client / fonctions sur mesure",
          "SEO, domaine et sécurité",
          "2 modifications majeures / semestre + 5 petites / 2 mois",
        ],
      },
    },

    included: [
      "Hébergement web inclus",
      "Nom de domaine offert",
      "Amélioration du référencement naturel Google (SEO)",
      "Modification de votre site internet",
      "Mises à jour de sécurité régulières",
      "Gestion du Google Business Profile (GBP)",
    ],

    includedChanges:
      "Modifications incluses",

    includedChangesDescription:
      "2 modifications majeures par semestre et jusqu'à 5 petites modifications tous les 2 mois. Une modification majeure supplémentaire est disponible pour 25 €.",

    /* -------------------------------------------------------
       MARQUEE
    ------------------------------------------------------- */

    marquee: [
      "HollowCorp",
      "Création de sites web",
      "Développement web",
      "Site vitrine",
      "Site e-commerce",
      "Référencement SEO",
      "Hébergement web",
      "Maintenance web",
    ],
  },

  /* =========================================================
     AVIS CLIENTS
  ========================================================= */

  testimonials: {
    overline: "[ EXEMPLES ]",

    title: "Deux façons",

    titleAccent: "d'exister en ligne.",

    reviews: [
      {
        quote:
          "L'Atelier du Quai est un restaurant fictif : accueil, carte, horaires, contact. C'est exactement ce qu'on livre en site vitrine — sans application derrière.",

        author: "L'Atelier du Quai",

        role: "Site vitrine — exemple HollowCorp",
      },

      {
        quote:
          "hollowcorp.fr est une web app : formulaires, emails, espace client, admin. Plus long à construire, plus cher à héberger, donc un premier mois et un abonnement plus élevés.",

        author: "hollowcorp.fr",

        role: "Web app — le site de HollowCorp",
      },
    ],
  },

  /* =========================================================
     FOOTER
  ========================================================= */

  footer: {
    ctaLine1: "Parlons de",

    ctaLine2: "votre projet",

    description:
      "Création de sites internet professionnels, référencement SEO, hébergement et maintenance : HollowCorp accompagne votre entreprise avec une solution web tout compris.",

    contact: "Contact",

    socials: "Réseaux",

    instagram: "Instagram",

    tiktok: "TikTok",

    microBusiness: "Micro-entreprise",

    legal: "Mentions légales & RGPD",

    staffArea: "Espace personnel",
  },

  /* =========================================================
     ADMIN
  ========================================================= */

  admin: {
    roles: {
      ceo: "CEO",
      manager: "Manager",
      employee: "Employé",
      client: "Client",
      staff: "Personnel",
    },

    login: {
      overline: "[ ESPACE PERSONNEL ]",
      title: "Admin.",

      ceoTab: "CEO",
      employeeTab: "Manager / Employé",

      adminDescription:
        "Identifiant Admin. Cliquez pour recevoir un code de connexion à usage unique sur l'adresse email HollowCorp.",

      receiveCode: "Recevoir mon code",

      codeSent: "Code envoyé à",
      codeValidity: "valable 10 min",
      codeError: "Impossible d'envoyer le code",

      codeLabel: "Code reçu par email",
      codePlaceholder: "123456",

      invalidCode: "Code invalide",
      ceoLogin: "Connexion CEO",

      emailLabel: "Email",
      emailPlaceholder: "vous@hollowcorp.fr",

      passwordLabel: "Mot de passe",
      passwordPlaceholder: "••••••••",

      invalidCredentials: "Identifiants invalides",
      employeeLogin: "Connexion",
    },

    dashboard: {
      title: "Tableau de bord",
      logout: "Déconnexion",

      requests: "Demandes",
      support: "Support",
      team: "Équipe",

      permissions: {
        ceo: "Accès complet",
        manager: "Gestion opérationnelle",
        employee: "Accès employé",
      },
    },

    requests: {
      title: "Demandes",

      empty: "Aucune demande reçue.",
      error: "Impossible de charger les demandes.",

      defaultProject: "Demande",

      received: "Reçu",
      inProgress: "En cours",
      delivered: "Livré",

      statusChanged: "Statut →",
      deleted: "Demande supprimée",

      readOnly: "Consultation uniquement",
      updateStatus: "Modifier le statut",
      deleteRequest: "Supprimer la demande",
    },

    support: {
      title: "Support",

      empty: "Aucune conversation.",
      selectConversation: "Sélectionnez une conversation",

      replyPlaceholder: "Répondre…",
      send: "Envoyer",

      resetPassword:
        "Réinitialiser le mot de passe",

      newPassword: "Nouveau :",

      forwardPassword:
        "Transmettez ce mot de passe temporaire à la personne (il n'est pas envoyé par email).",

      close: "Fermer",

      passwordReset:
        "Mot de passe réinitialisé",

      conversationDeleted:
        "Conversation supprimée",

      resetError:
        "Une erreur est survenue.",

      deleteConversation:
        "Supprimer le chat",

      clientPasswordReset:
        "Réinitialiser le mot de passe du client",

      reply:
        "Répondre au client",

      delete:
        "Supprimer la conversation",
    },

    team: {
      title: "Équipe",

      recruit: "Recruter",
      members: "Équipe",

      name: "Nom",
      email: "Email",
      password: "Mot de passe (min. 6)",

      role: "Rôle",

      employee: "Employé",
      manager: "Manager",

      managerOnlyCeo:
        "(CEO uniquement)",

      createAccount:
        "Créer le compte",

      created: "créé",

      deleted:
        "Membre supprimé",

      empty:
        "Aucun membre.",

      error:
        "Une erreur est survenue.",

      resetPassword:
        "Réinitialiser le mot de passe",

      delete:
        "Supprimer",

      permissions: {
        ceo: {
          title:
            "Gestion complète de l'équipe",

          createEmployee:
            "Créer un employé",

          createManager:
            "Créer un manager",

          deleteEmployee:
            "Supprimer un employé",

          deleteManager:
            "Supprimer un manager",

          resetPassword:
            "Réinitialiser les mots de passe",
        },

        manager: {
          title:
            "Gestion des employés",

          createEmployee:
            "Créer un employé",

          createManager:
            "Créer un manager",

          deleteEmployee:
            "Supprimer un employé",

          deleteManager:
            "Supprimer un manager",

          resetPassword:
            "Réinitialiser les mots de passe",
        },

        employee: {
          title:
            "Accès employé",

          createEmployee:
            "Créer un employé",

          createManager:
            "Créer un manager",

          deleteEmployee:
            "Supprimer un employé",

          deleteManager:
            "Supprimer un manager",

          resetPassword:
            "Réinitialiser les mots de passe",
        },
      },
    },

    access: {
      ceo: {
        label: "CEO",

        description:
          "Accès complet à l'administration de HollowCorp.",

        requests: {
          view: true,
          update: true,
          delete: true,
        },

        support: {
          view: true,
          reply: true,
          delete: true,
          resetPassword: true,
        },

        team: {
          view: true,
          createEmployee: true,
          createManager: true,
          deleteEmployee: true,
          deleteManager: true,
          resetPassword: true,
        },
      },

      manager: {
        label: "Manager",

        description:
          "Gestion opérationnelle de l'équipe et des clients.",

        requests: {
          view: true,
          update: true,
          delete: false,
        },

        support: {
          view: true,
          reply: true,
          delete: false,
          resetPassword: true,
        },

        team: {
          view: true,
          createEmployee: true,
          createManager: false,
          deleteEmployee: true,
          deleteManager: false,
          resetPassword: true,
        },
      },

      employee: {
        label: "Employé",

        description:
          "Accès aux tâches et au support client.",

        requests: {
          view: true,
          update: true,
          delete: false,
        },

        support: {
          view: true,
          reply: true,
          delete: false,
          resetPassword: false,
        },

        team: {
          view: false,
          createEmployee: false,
          createManager: false,
          deleteEmployee: false,
          deleteManager: false,
          resetPassword: false,
        },
      },

      client: {
        label: "Client",

        description:
          "Accès réservé aux clients.",

        requests: {
          view: false,
          update: false,
          delete: false,
        },

        support: {
          view: false,
          reply: false,
          delete: false,
          resetPassword: false,
        },

        team: {
          view: false,
          createEmployee: false,
          createManager: false,
          deleteEmployee: false,
          deleteManager: false,
          resetPassword: false,
        },
      },
    },

    permissions: {
      denied:
        "Vous ne disposez pas des permissions nécessaires.",

      ceoOnly:
        "Cette action est réservée au CEO.",

      managerOnly:
        "Cette action est réservée au CEO ou au Manager.",

      employeeOnly:
        "Cette action est réservée aux employés.",
    },

    errors: {
      unauthorized:
        "Accès non autorisé.",

      forbidden:
        "Vous n'avez pas accès à cette fonctionnalité.",

      server:
        "Erreur serveur.",

      network:
        "Impossible de contacter le serveur.",

      unknown:
        "Une erreur est survenue.",
    },

    success: {
      saved:
        "Modifications enregistrées.",

      updated:
        "Mise à jour effectuée.",

      deleted:
        "Suppression effectuée.",

      created:
        "Compte créé.",
    },
  },
};

export default fr;